import React from 'react';
import Modal from 'react-modal';
import { motion, AnimatePresence } from 'framer-motion';
import '../assets/css/NavBarModal.css';
import { RxCross2 } from 'react-icons/rx';

Modal.setAppElement('#root');

const NavbarModal = ({ isOpen, closeModal, children }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <Modal
            isOpen={isOpen}
            onRequestClose={closeModal}
            shouldCloseOnOverlayClick={true}
            closeTimeoutMS={300}
            overlayClassName="custom-overlay"
            className="custom-content-wrapper"
          >
            <motion.div
              className="modal-box"
              initial={{ opacity: 0, y: -100 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -100 }}
              transition={{ duration: 0.3 }}
            >
              <div className='d-flex justify-content-end ' onClick={closeModal}>
                <RxCross2 className='me-3 mt-3 fs-3' />
              </div>
              {children}
            </motion.div>
          </Modal>
        </>
      )}
    </AnimatePresence>
  );
};

export default NavbarModal;
